var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.0192308)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 52,
    height: 52,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAABmJLR0QA/wD/AP+gvaeTAAADyklEQVRYCe2ZT0gUURzHZ2ZXW/+UEAphuuJe9maFJhQRCnVK6BIeQiqlQ9ApiIi6daibEUH/0P7QoUOnLh4qiIhQySL6QwgisquCaATV2mq62+dtM8Pb0Rk1ZsY/zfL97vv93rx5v9/3vTezb2YVJfgEIxCMQDACG3kE1OWKq6mp2ZXNZo+pqnqAc7bBcuglpuh8gpjPMpnM3dHR0Y/4S2JJQRUVFaVFRUVdCGmltyXb08YLZIjfNTs7e2Z8fHzaKYBjgpWVlcUFBQUv6aABrgUMpNPppomJiZRdMprdAVFfWFh4k3KtiCEVpYHVckMYdlTtDtTW1jaydvs4Lrf5jH9ubm6uf2xs7Cu2Z2B1lLM6GglwCdZDA1nyakwmkwNGhVyGZUe25+fn21U+Ut27SCTSNDg4+EOq88zkWpmi856qqqoXoVCoF3sHFFA1TTuhKMoAXABtQY1egZZm3cwV+Bf8EpMLqH9xd/uFeRHKyMtNPmAriEbboYlUKvXadHw2WHqvLCGrLL7pOgkqNVthTE5O/qRYFQwNDX23BN5i8U3XSZDZaD0ZG06Q7V3OzVnRdxtxo09u+1+4i00bvpulL4KKi4uvkvRJmEM4HG7AeAtdh+dLrrq6ejdZd0BfoHkcRfwIXiOG13EI8ReeBopGo22E2QN9g2eCYrFYlN3FdaGEZ5qkKP2gV4JC7AUfIaAM/kbYeUpf4IkgltpZst8LBW4zQ4PC8IOuC0JMCzNyWU/+A/swIU53vS9cFYSYGGIekLbodxr7OPuwGXzfIAK7EoybQBkCeuhsK8xgHx0ZGXmP7SvCbkXjJnCEvuJQIMN108mbok7hwE3QBGKfcGyGJ8/DPHl+Mg+4YLgmCAEhEjVSEv3GDGeRMvesRfs8oYu0W3GVtuIz1vgJYiRdSTGRSNyhI0GKfHCzqGc2BoxaZrOB9utzc2qI8KsMltw/jvQwy6xVOndYsl01XbuGnLLievnG8cfQc2y4JfdfCUrJ60O86JB9P+14PL7ZEu+nxTddpxlKmK0wSkpK9lGsCvgLZb8lcF5u8jFNdiz2c9nnLnUlvnCk5Cae2PrKMB5HcjH4kc7LLVepfzkJukebLDSwk5HqZVN5SA9i1HtSisFjh9HCK7B+AtRBA2In32041lK1Vsg+yT/Eb4NrBqyU+/wMtNsl5DRDCjNyiul9Y3fyKtT38db1tFNcR0Hiv0z+qG1SFKULZuBqIcPM3GJwm5d6hawuN0P+oqyj0w54kHNiMAK9RJrOh4n3FHa7/SBI3wGCEQhGIBiBdTgCfwD53gMxcf2/ywAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFour);
export default __webpack_public_path__ + "static/media/four.eae4680effa31b5950fa86c06c7825fb.svg";
export { ForwardRef as ReactComponent };